/**
 * Поля формы «Монтаж завершён»: получатели, предварительное время, количество файлов, размер, комментарий.
 */
import { useRef } from 'react';
import { UserRecipientCombo, type RecipientUserItem } from '@/components/UserRecipientCombo/UserRecipientCombo';
import { Input } from '@/components/ui/Input/Input';
import { Textarea } from '@/components/ui/Textarea/Textarea';
import { TimeInput } from '@/components/ui/TimeInput/TimeInput';

export interface MountingCompleteEmailFieldsProps {
  recipients: RecipientUserItem[];
  onRecipientsChange: (items: RecipientUserItem[]) => void;
  ccUsers: RecipientUserItem[];
  onCcUsersChange: (items: RecipientUserItem[]) => void;
  time: string;
  onTimeChange: (value: string) => void;
  filesCount: string;
  onFilesCountChange: (value: string) => void;
  sizeValue: string;
  onSizeValueChange: (value: string) => void;
  commentNote: string;
  onCommentNoteChange: (value: string) => void;
  disabled?: boolean;
}

export function MountingCompleteEmailFields({
  recipients,
  onRecipientsChange,
  ccUsers,
  onCcUsersChange,
  time,
  onTimeChange,
  filesCount,
  onFilesCountChange,
  sizeValue,
  onSizeValueChange,
  commentNote,
  onCommentNoteChange,
  disabled,
}: MountingCompleteEmailFieldsProps) {
  const recipientRef = useRef<HTMLDivElement>(null);
  const ccComboRef = useRef<HTMLDivElement>(null);

  return (
    <div className="review-check-email-modal__fields">
      <div className="review-check-email-modal__field">
        <UserRecipientCombo
          value={recipients}
          onChange={onRecipientsChange}
          placeholder="Получатель"
          containerRef={recipientRef}
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__field">
        <UserRecipientCombo
          value={ccUsers}
          onChange={onCcUsersChange}
          placeholder="Копия"
          containerRef={ccComboRef}
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__row review-check-email-modal__row_cols-3">
        <div className="review-check-email-modal__field">
          <TimeInput value={time} onChange={onTimeChange} placeholder="00:00:00" fullWidth disabled={disabled} />
        </div>
        <div className="review-check-email-modal__field">
          <Input
            value={filesCount}
            onChange={(e) => onFilesCountChange(e.target.value.replace(/[^\d]/g, ''))}
            placeholder="Количество файлов"
            fullWidth
            disabled={disabled}
          />
        </div>
        <div className="review-check-email-modal__field">
          <Input
            value={sizeValue}
            onChange={(e) => {
              const v = e.target.value.replace(',', '.').replace(/[^\d.]/g, '');
              const parts = v.split('.');
              if (parts.length <= 1) onSizeValueChange(v);
              else onSizeValueChange(parts[0] + '.' + parts.slice(1).join(''));
            }}
            placeholder="Размер (ГБ)"
            fullWidth
            disabled={disabled}
          />
        </div>
      </div>
      <div className="review-check-email-modal__field">
        <Textarea
          value={commentNote}
          onChange={(e) => onCommentNoteChange(e.target.value)}
          placeholder="Комментарий к письму"
          fullWidth
          minRows={1}
          maxRows={40}
          inputClassName="review-check-email-modal__comment-input"
          disabled={disabled}
        />
      </div>
    </div>
  );
}
